
import algoliasearch from 'algoliasearch/lite'
import Pagination from '../ais-search/Pagination.vue'
import MenuSelect from '../ais-search/MenuSelect.vue'
import SortByDesktop from '../ais-search/SortByDesktop.vue'
import SortByMobile from '../ais-search/SortByMobile.vue'

export default {
  components: { Pagination, MenuSelect, SortByDesktop, SortByMobile },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      // If sort and view select is hidden, start out with list view
      gridView: this.data.results_as_grid,

      searchClient: algoliasearch(
        this.$config.algoliaAppId,
        this.$config.algoliaApiKey
      ),

      indexName: this.$config.algoliaProductIndex,

      sortItems: [
        {
          value: `${this.$config.algoliaProductIndex}_instant_search_popularity`,
          label: 'Beliebtheit',
        },
        {
          value: `${this.$config.algoliaProductIndex}_instant_search_price_asc`,
          label: 'Preis aufsteigend',
        },
        {
          value: `${this.$config.algoliaProductIndex}_instant_search_price_desc`,
          label: 'Preis absteigend',
        },
      ],

      openFilter: false,
      filterCleared: false,
    }
  },

  computed: {
    filters() {
      let filters = `collection:products`
      if (this.data.filter_attribute?.key && this.data.filter_value) {
        filters += ` AND ${this.data.filter_attribute.key}:'${this.data.filter_value}'`
      }

      return filters
    },

    options() {
      return {
        filters: this.filters,
        maxValuesPerFacet: 50,
      }
    },
  },

  methods: {
    toggleFilterModal() {
      this.openFilter = !this.openFilter
    },

    clearFilter() {
      this.filterCleared = true

      this.$nextTick(() => {
        this.filterCleared = false
      })
    },

    scrollToTop() {
      const titleElement = document.getElementById('filter-top')
      titleElement.scrollIntoView({ block: 'start', behavior: 'smooth' })
    },
  },
}
